import React from "react";

import { Button, Tabs } from "../ui";
import type { TabItem } from "../ui/Tabs";

export type SmeWorkspaceTab = "assessment" | "chat";

export type SmeProjectWorkspaceProps = {
  projectName: string;
  projectMeta?: string;
  activeTab: SmeWorkspaceTab;
  hasUnreadChat: boolean;
  onTabChange: (tab: SmeWorkspaceTab) => void | Promise<void>;
  onBack: () => void | Promise<void>;
  assessmentPanel: React.ReactNode;
  chatPanel: React.ReactNode;
  footer?: React.ReactNode;
};

export function SmeProjectWorkspace({
  projectName,
  projectMeta,
  activeTab,
  hasUnreadChat,
  onTabChange,
  onBack,
  assessmentPanel,
  chatPanel,
  footer,
}: SmeProjectWorkspaceProps) {
  const tabs: TabItem[] = [
    {
      id: "assessment",
      label: "Assessment",
      content: assessmentPanel,
    },
    {
      id: "chat",
      label: (
        <span className="sme-workspace__tab-label">
          Chat
          {hasUnreadChat ? (
            <span className="sme-workspace__tab-badge" title="New message">
              New
            </span>
          ) : null}
        </span>
      ),
      content: chatPanel,
    },
  ];

  return (
    <div className="sme-workspace">
      <section className="sme-workspace__shell" aria-label="Project workspace">
        <header className="sme-workspace__header">
          <div className="sme-workspace__project">
            <p className="sme-workspace__eyebrow">Active project</p>
            <h2 className="sme-workspace__title">{projectName}</h2>
            {projectMeta ? (
              <p className="sme-workspace__meta">{projectMeta}</p>
            ) : null}
          </div>
          <Button
            type="button"
            variant="secondary"
            size="sm"
            className="sme-workspace__back"
            onClick={() => onBack()}
          >
            Back to projects
          </Button>
        </header>

        <Tabs
          className="sme-workspace__tabs"
          variant="segmented"
          keepMounted
          tabs={tabs}
          value={activeTab}
          onChange={(id) => onTabChange(id as SmeWorkspaceTab)}
        />
      </section>

      {footer ? <div className="sme-workspace__footer">{footer}</div> : null}
    </div>
  );
}

export default SmeProjectWorkspace;
